export default __webpack_public_path__ + "static/media/vivek_details_image.8005ed53.png";